var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTruck = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.75 7H18v2h3.75l3.75 5.994L28 15l-5-8zM2.027 22H0v-7h28v7h-2.027a4.5 4.5 0 0 0-8.946 0h-6.054a4.5 4.5 0 0 0-8.946 0M0 3h18v12H0zm21.5 22a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m-15 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
  })));
};
export default SvgTruck;